import React, { useEffect } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DialogActions, InputAdornment, TextField } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EventIcon from "@mui/icons-material/Event"; // Import new icon

import '../../styles/Common/CustomDatePicker.scss'
import dayjs from 'dayjs';
import CalendarIcon from '../../assets/Icons/CalendarIcon';
const CustomDatePicker = (props) => {
  const { format = 'DD-MMM-YYYY', onChange = () => { }, selectedDate = null, label = '', minDate = dayjs(new Date()), showIcon = true, disabled = false, iconsPosition = 'start' } = props
  const [isOpen, setIsOpen] = React.useState(false);
  const [value, setValue] = React.useState(null); // Manage selected date


  useEffect(() => {
    setValue(dayjs(selectedDate))
  }, [selectedDate])
  function CustomCalendarHeader(props) {
    const { currentMonth, onMonthChange } = props;
    const selectNextMonth = () => onMonthChange(currentMonth.add(1, 'month'), 'left');
    const selectPreviousMonth = () =>
      onMonthChange(currentMonth.subtract(1, 'month'), 'right');
    const headerContainerStyle = {
      backgroundColor: '#0086ff',
      height: '50px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 10px',
      color: '#fff',
    };

    const customCalendarHeaderRootStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 2px',
    };
    return (
      <>
        <div style={headerContainerStyle} >
          <IconButton title="Previous year" aria-label="Previous year" onClick={() => {
            setIsOpen(false)
          }}>
            <ArrowBackIcon style={{ color: '#fff', width: '20px', height: '40px' }} />
          </IconButton>
          <div>Select Date</div>
          <IconButton title="Next year" aria-label="Next year" >
            <ArrowBackIcon style={{ transform: 'rotate(180deg)', color: '#fff', visibility: 'hidden', width: '20px', height: '40px' }} />
          </IconButton>
        </div>
        <div style={customCalendarHeaderRootStyle}>
          <Stack spacing={1} direction="row">
            <IconButton onClick={selectPreviousMonth} title="Previous month" aria-label="Previous month">
              <ChevronLeft />
            </IconButton>
          </Stack>
          <Typography variant="body2" sx={{ fontSize: '1rem' }}>{currentMonth.format('MMMM YYYY')}</Typography>
          <Stack spacing={1} direction="row">
            <IconButton onClick={selectNextMonth} title="Next month" aria-label="Next month">
              <ChevronRight />
            </IconButton>
          </Stack>
        </div>
      </>
    );
  }

  const CustomTextField = (params) => (
    <TextField
      {...params}
      onClick={handleTextFieldClick} // Opens modal on TextField click
      inputProps={{ ...params.inputProps, readOnly: true }}
      sx={{
        width: "100%",
        backgroundColor: "white",
        "& label.Mui-focused": {
          color: "#004F9E !important",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: isOpen ? "#004F9E" : "#a6a8ab",
          },
          "&:hover fieldset": {
            borderColor: isOpen ? "#004F9E" : "#a6a8ab",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#004F9E",
          },
        },
      }}
      InputProps={
        iconsPosition === 'end' ? {
          endAdornment: showIcon ? (
            <InputAdornment position="end">
              <CalendarIcon height={18} />  {/* Updated Icon */}
            </InputAdornment>
          ) : null
        } : {
          startAdornment: showIcon ? (
            <InputAdornment position="start">
              <CalendarIcon />  {/* Updated Icon */}
            </InputAdornment>
          ) : null
        }
      }
      InputLabelProps={{
        style: { color: isOpen ? "#004F9E" : "#666666" },
      }}

    />
  );
  const handleTextFieldClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const CustomActionBar = () => {
    return (
      <DialogActions style={{ display: 'flex', justifyContent: 'center', padding: '10px 2px', width: '100vw', position: 'absolute', bottom: '0px' }}>
        <span
          style={{
            cursor: 'pointer',
            marginTop: 'auto',
          }}
          onClick={() => {
            handleDateChange(new Date())
          }}
        >
          Today's Date : <span style={{ fontWeight: '600' }}>
            {dayjs(window.getTime ? window.getTime() : new Date()).format('DD-MM-YYYY')}
          </span>
        </span>
      </DialogActions>
    );
  };
  const handleDateChange = (newValue) => {
    setValue(dayjs(newValue));
    onChange(dayjs(newValue));
    handleClose();
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DesktopDatePicker']}>
        <DesktopDatePicker
          className="datePicker"
          label={label}
          value={value}
          onChange={handleDateChange}
          minDate={minDate}
          disabled={disabled}
          slots={{
            calendarHeader: CustomCalendarHeader,
            textField: CustomTextField,
            actionBar: CustomActionBar
          }}

          format={format}
          open={isOpen}
          onClose={handleClose}
        />
      </DemoContainer>

    </LocalizationProvider>
  )
}

export default CustomDatePicker